import React from "react";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";

import Grid from "@material-ui/core/Grid";
import { Controller, useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup"
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { useTranslation, Trans } from "react-i18next";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import { InputAdornment } from "@material-ui/core";
import { Icon } from "@material-ui/core";
import { FormHelperText, makeStyles } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';


const useStylesAll = makeStyles((theme) => ({}));

const placeholderValue = {};

function RegisterStep1Page(props) {
  const {
    currentStep,
    handleChange,
    handleDateChange,
    firstName,
    lastName,
    gender,
    address,
    contactNumber,
    email,
    password,
    repassword,
    dob,
    occupation,
    errorMessage,
    renew,
    resumepay,
    canUpdateDob,
    isExistingMember,
  } = props;
  const { t, i18n } = useTranslation("register");
  const classes = useStylesAll();
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [placeholder, setPlaceholder] = React.useState(placeholderValue);
  const [showPassword, setShowPassword] = React.useState(false);

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    formState,
  } = useForm({});

  const loginUrl = React.useMemo(() => `${window.location.href.split(`/${i18n.language}`)[0]}/${i18n.language}/login`, [i18n.language])

  const getRegisterInfo = React.useCallback(async () => {
    try {
      // setLoading(true);
      // var newDefaultFormValues = defaultFormValues;
      // setDefaultValues(newDefaultFormValues);
      // reset(newDefaultFormValues);
    } catch (err) {
      console.log(err);
    } finally {
      // setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    getRegisterInfo();
  }, [getRegisterInfo]);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return currentStep == 1 ? (
    <Grid item xs={12}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h2">{t("pleasefillform")}</Typography>
        </Grid>

        {(!renew && !resumepay) &&
          <Grid item xs={12}>
            <Controller
              name="isExistingMember"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <>
                  <FormControlLabel
                    className={classes.label}
                    control={
                      <Checkbox
                        id="isExistingMember"
                        className={classes.checkbox}
                        type="checkbox"
                        name="isExistingMember"
                        color="primary"
                        error={!!errorMessage.isExistingMember}
                        checked={isExistingMember}
                        onChange={handleChange}
                      />
                    }
                    label={t('currentholder')}
                  />
                </>
              )}
            />
          </Grid>

        }

        <Grid item xs={12}>
          <Controller
            name="firstName"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <InputLabel htmlFor="firstName" variant="outlined">
                  {t("firstName.label")}
                </InputLabel>
                <TextField
                  id="firstName"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  placeholder={t("firstName.placeholder")}
                  fullWidth
                  {...field}
                  error={!!errorMessage.firstName}
                  helperText={
                    errorMessage.firstName && t(errorMessage.firstName)
                  }
                  defaultValue={firstName}
                  onChange={!renew && !resumepay ? handleChange : ""}
                  disabled={renew || resumepay}
                />
              </>
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name="lastName"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <InputLabel htmlFor="lastName" variant="outlined">
                  {t("lastName.label")}
                </InputLabel>
                <TextField
                  id="lastName"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  placeholder={t("lastName.placeholder")}
                  fullWidth
                  {...field}
                  error={!!errorMessage.lastName}
                  helperText={errorMessage.lastName && t(errorMessage.lastName)}
                  defaultValue={lastName}
                  onChange={!renew && !resumepay ? handleChange : ""}
                  disabled={renew || resumepay}
                />
              </>
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <InputLabel htmlFor="gender" variant="outlined">
            {t("gender")}
          </InputLabel>
          <ToggleButtonGroup
            id="gender"
            value={gender}
            defaultValue={gender}
            exclusive
            onChange={handleChange}
            aria-label="gender"
            size="large"
            style={{
              width: "100%",
              height: "60px",
              color: "#000000",
              marginTop: "7px",
            }}
          >
            <ToggleButton name="gender" value="0" aria-label="0">
              <span>{t("male")}</span>
            </ToggleButton>
            <ToggleButton name="gender" value="1" aria-label="1">
              <span>{t("female")}</span>
            </ToggleButton>
            <ToggleButton name="gender" value="2" aria-label="2">
              <span>{t("others")}</span>
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>

        <Grid item xs={12}>
          <Controller
            name="address"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <InputLabel htmlFor="address" variant="outlined">
                  <span style={{ display: "block", marginBottom: "10px" }}>
                    {t("address.label")}
                  </span>
                  {t("address.desc")}
                </InputLabel>
                <TextField
                  id="address"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  placeholder={t("address.placeholder")}
                  fullWidth
                  {...field}
                  error={!!errorMessage.address}
                  helperText={errorMessage.address && t(errorMessage.address)}
                  defaultValue={address}
                  onChange={handleChange}
                />
              </>
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name="contactNumber"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <InputLabel htmlFor="contactNumber" variant="outlined">
                  <span style={{ display: "block", marginBottom: "10px" }}>
                    {t("contactNumber.label")}
                  </span>
                  {t("contactNumber.desc")}
                </InputLabel>
                <TextField
                  id="contactNumber"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  placeholder={t("contactNumber.placeholder")}
                  fullWidth
                  {...field}
                  error={!!errorMessage.contactNumber}
                  helperText={
                    errorMessage.contactNumber && <Trans
                      t={t}
                      i18nKey={errorMessage.contactNumber}
                      values={{ loginUrl }}
                      components={[ <a href={loginUrl} /> ]}
                    />
                  }
                  defaultValue={contactNumber}
                  onChange={!renew && !resumepay ? handleChange : ""}
                  disabled={renew || resumepay}
                />
              </>
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name="email"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <InputLabel htmlFor="email" variant="outlined">
                  {t("email.label")}
                </InputLabel>
                <TextField
                  id="email"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  placeholder={t("email.placeholder")}
                  fullWidth
                  {...field}
                  error={!!errorMessage.email}
                  helperText={errorMessage.email && t(errorMessage.email)}
                  defaultValue={email}
                  onChange={handleChange}
                />
              </>
            )}
          />
        </Grid>

        {(!renew || resumepay) ? (
          <>
            <Grid item xs={12}>
              <Controller
                name="password"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="password" variant="outlined">
                      <span style={{ display: "block", marginBottom: "10px" }}>
                        {t("password.label")}
                      </span>
                      <span>{t("repassword.formaterror")}</span>
                    </InputLabel>
                    <TextField
                      id="password"
                      variant="outlined"
                      type={showPassword ? 'text' : 'password'}
                      margin="dense"
                      className={classes.textInput}
                      // placeholder={t('password.placeholder')}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position={"end"} onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                      {...field}
                      error={!!errorMessage.password}
                      helperText={
                        errorMessage.password && t(errorMessage.password)
                      }
                      defaultValue={password}
                      onChange={handleChange}
                    />
                  </>
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="repassword"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="repassword" variant="outlined">
                      {t("repassword.label")}
                    </InputLabel>
                    <TextField
                      id="repassword"
                      variant="outlined"
                      type={showPassword ? 'text' : 'password'}
                      margin="dense"
                      className={classes.textInput}
                      // placeholder={t('repassword.placeholder')}
                      fullWidth
                      {...field}
                      error={!!errorMessage.repassword}
                      helperText={
                        errorMessage.repassword && t(errorMessage.repassword)
                      }
                      defaultValue={password}
                      onChange={handleChange}
                    />
                  </>
                )}
              />
            </Grid>
          </>
        ) : (
            <></>
          )}

        <Grid item xs={12}>
          <Controller
            name="dob"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <InputLabel htmlFor="dob" variant="outlined">
                  {t("dob.label")}
                </InputLabel>

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    fullWidth
                    variant="outlined"
                    inputVariant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position={"end"}>
                          <CalendarTodayIcon />
                        </InputAdornment>
                      ),
                    }}
                    margin="dense"
                    openTo="year"
                    views={["year", "month"]}
                    placeholder={t("dob.placeholder")}
                    format="MM/yyyy"
                    value={dob}
                    onChange={canUpdateDob ? handleChange : ""}
                    error={!!errorMessage.dob}
                    disabled={!canUpdateDob}
                  />
                  <FormHelperText style={{ color: "red" }}>
                    {errorMessage.dob && t(errorMessage.dob)}
                  </FormHelperText>

                  {/* <KeyboardDatePicker
                        clearable
                        fullWidth
                        inputVariant="outlined"
                        placeholder="MM/YYYY"
                        value={dob}
                        onChange={date => handleChange(date)}
                        openTo="year"
                        views={["year", "month"]}
                        format="MM/yyyy"
                      /> */}
                </MuiPickersUtilsProvider>
              </>
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  ) : (
      <></>
    );
}

export default RegisterStep1Page;
